<template>
  <BaseButton class="self-start" @click="downloadCsv()">
    <BaseIcon :icon="Icon.DOWNLOAD" class="inline h-5 w-5" />
    {{ t("genericTable.download") }}
  </BaseButton>
</template>

<script setup lang="ts" generic="T extends GenericTableSchema">
import { useI18n } from "vue-i18n";
import { Icon } from "../../../../assets/icons/Icon";
import BaseButton from "../../../../components/BaseButton.vue";
import BaseIcon from "../../../../components/BaseIcon.vue";
import { downloadEntitiesAsCsv } from "../../service.genericTable";
import { GenericTableQuery } from "../../type.genericTableQuery";
import { GenericTableSchema } from "../../type.genericTableSchema";
const { t } = useI18n();
const props = defineProps<{
  schema: T;
  endpointUrl: string;
}>();
const query = defineModel<GenericTableQuery<T>>({ required: true });

async function downloadCsv() {
  await downloadEntitiesAsCsv({
    path: props.endpointUrl,
    query: {
      ...query.value,
      select: undefined,
      pagination: undefined,
    },
    schema: props.schema,
  });
}
</script>
